import React from 'react';

export function DeviceSvg() {
  return (
    <svg
      width="12"
      height="16"
      viewBox="0 0 12 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10.3047 0H2.30469C1.47769 0 0.804688 0.673 0.804688 1.5V14.5C0.804688 15.327 1.47769 16 2.30469 16H10.3047C11.1317 16 11.8047 15.327 11.8047 14.5V1.5C11.8047 0.673 11.1317 0 10.3047 0ZM10.8047 13.5C10.8047 13.776 10.5807 14 10.3047 14H2.30469C2.02869 14 1.80469 13.776 1.80469 13.5V2.5C1.80469 2.224 2.02869 2 2.30469 2H10.3047C10.5807 2 10.8047 2.224 10.8047 2.5V13.5Z"
        fill="#111111"
      />
    </svg>
  );
}
